import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/chat/page.tsx");
